import { FC } from 'react';

import type { FieldOverrideProps } from './Field.types';

export const Field: FC<FieldOverrideProps> = () => null;
